$( document ).ready(function(){
  $(".upload-more-btn").click(function(){
    var nextFileFieldIndex = $(".item-image").length
    var $nextFileField = $("#user_user_images_attributes_" + nextFileFieldIndex + "_image")
    $nextFileField.trigger('click');
  });

  //fileが選択された時に発火するイベント
  $('.img-file').change(function(){
    var maxExceededMessage = "10MB以下の画像をアップロードしてください。";
    var extErrorMessage = "推奨されている画像形式はjpg, jpeg, pngです。それ以外の場合、正しく保存されないことがあります";
    var allowedExtension = ["jpg", "jpeg", "gif", "png"];

    var extName;
    var maxFileSize = 10;
    var sizeExceeded = false;
    var extError = false;

    $.each(this.files, function(i, file){
      if (file.size && maxFileSize && file.size/1024/1024 > maxFileSize) {sizeExceeded=true;};
      extName = file.name.split('.').pop();
      if ($.inArray(extName, allowedExtension) == -1) {extError=true;};
    });
    if (sizeExceeded) {
      window.alert(maxExceededMessage);
      $(file).val('');
      return
    };    

    $.each(this.files, function(i, file){
      //FileReaderのreadAsDataURLで指定したFileオブジェクトを読み込む
      var fileReader = new FileReader();
      var num = $('.item-image').length + 1 + i
      fileReader.readAsDataURL(file);

　　　 //画像が10枚になったら超えたらドロップボックスを削除する
      if (num == 5){ $('#image-box__container').css('display', 'none') }

      //読み込みが完了すると、srcにfileのURLを格納
      fileReader.onloadend = function() {
        var src = fileReader.result
        var html= `<div class='item-image' data-image="${file.name}">
                    <div class=' item-image__content'>
                      <div class='item-image__content--icon' style="background-image:url('${src}')">
                      </div>
                    </div>
                    <div class='item-image__operetion'>
                      <div class='item-image__delete-btn'><i class="fas fa-trash"></i></div>
                    </div>
                  </div>`
        //image_box__container要素の前にhtmlを差し込む
        $('#image-box__container').before(html);
      };
      //image-box__containerのクラスを変更し、CSSでドロップボックスの大きさを変えてやる。
      $('#image-box__container').attr('class', `item-num-${num}`)
    });
    if (extError) {
      window.alert(extErrorMessage);
    };
  });

  //削除ボタンをクリックすると発火するイベント
  $(document).on("click", '.item-image__delete-btn', function(){

    var target_image = $(this).parent().parent()
    var target_name = $(target_image).data('image')
    var targetFileFieldIndex = $(".item-image").index( target_image )
    var $targetFileField = $("#user_user_images_attributes_" + targetFileFieldIndex + "_image")

    // DB保存済み画像の場合、削除したいファイル名の一覧を送信して、コントラーラー側で画像を削除
    if(target_image.hasClass("existing-image")){
      var oldValue = $("#deleted-image-names").val()
      var newValue = oldValue + " " + target_name
      $("#deleted-image-names").val(newValue)
    }

    // DB未保存画像の場合、file inputから削除
    if(!target_image.hasClass("existing-image")){
      $targetFileField.val(null)
    }

    //プレビューを削除
    target_image.remove()
    //image-box__containerクラスをもつdivタグのクラスを削除のたびに変更
    var num = $('.item-image').length
    $('#image-box__container').show()
    $('#image-box__container').attr('class', `item-num-${num}`)
  })


  // 出品画像用の記述
  $(".sample-upload-more-btn").click(function(){
    console.log("ddafda")
    var nextFileFieldIndex = $(".sample-item-image").length
    var $nextFileField = $("#user_session_sample_images_attributes_" + nextFileFieldIndex + "_image")
    $nextFileField.trigger('click');
  });

  //fileが選択された時に発火するイベント
  $('.sample-img-file').change(function(){
    var maxExceededMessage = "10MB以下の画像をアップロードしてください。";
    var extErrorMessage = "推奨されている画像形式はjpg, jpeg, pngです。それ以外の場合、正しく保存されないことがあります";
    var allowedExtension = ["jpg", "jpeg", "gif", "png"];

    var extName;
    var maxFileSize = 10;
    var sizeExceeded = false;
    var extError = false;
    var isGameCoach = $(this).hasClass("sample-img-file--game-coach")

    $.each(this.files, function(i, file){
      if (file.size && maxFileSize && file.size/1024/1024 > maxFileSize) {sizeExceeded=true;};
      extName = file.name.split('.').pop();
      if ($.inArray(extName, allowedExtension) == -1) {extError=true;};
    });
    if (sizeExceeded) {
      window.alert(maxExceededMessage);
      $(file).val('');
      return
    };    

    $.each(this.files, function(i, file){
      //FileReaderのreadAsDataURLで指定したFileオブジェクトを読み込む
      var fileReader = new FileReader();
      var num = $('.sample-item-image').length + 1 + i
      fileReader.readAsDataURL(file);

      if(isGameCoach){
        if (num == 9){ $('#sample-image-box__container').css('display', 'none') }
      }else{
        //画像が10枚になったら超えたらドロップボックスを削除する
        if (num == 6){ $('#sample-image-box__container').css('display', 'none') }
      }

      //読み込みが完了すると、srcにfileのURLを格納
      fileReader.onloadend = function() {
        var src = fileReader.result
        var html= `<div class='sample-item-image' data-image="${file.name}">
                    <div class='sample-item-image__content'>
                      <div class='sample-item-image__content--icon' style="background-image:url('${src}')">
                      </div>
                    </div>
                    <div class='sample-item-image__operetion'>
                      <div class='sample-item-image__delete-btn'><i class="fas fa-trash"></i></div>
                    </div>
                  </div>`
        //image_box__container要素の前にhtmlを差し込む
        $('#sample-image-box__container').before(html);
      };
      //image-box__containerのクラスを変更し、CSSでドロップボックスの大きさを変えてやる。
      $('#sample-image-box__container').attr('class', `sample-item-num-${num}`)
    });
    if (extError) {
      window.alert(extErrorMessage);
    };
  });

  //削除ボタンをクリックすると発火するイベント
  $(document).on("click", '.sample-item-image__delete-btn', function(){

    var target_image = $(this).parent().parent()
    var target_name = $(target_image).data('image')
    var targetFileFieldIndex = $(".sample-item-image").index( target_image )
    var $targetFileField = $("#user_session_sample_images_attributes_" + targetFileFieldIndex + "_image")

    // DB保存済み画像の場合、削除したいファイル名の一覧を送信して、コントラーラー側で画像を削除
    if(target_image.hasClass("existing-image")){
      var oldValue = $("#sample-deleted-image-names").val()
      var newValue = oldValue + " " + target_name
      $("#sample-deleted-image-names").val(newValue)
    }

    // DB未保存画像の場合、file inputから削除
    if(!target_image.hasClass("sample-existing-image")){
      $targetFileField.val(null)
    }

    //プレビューを削除
    target_image.remove()
    //image-box__containerクラスをもつdivタグのクラスを削除のたびに変更
    var num = $('.sample-item-image').length
    $('#sample-image-box__container').show()
    $('#sample-image-box__container').attr('class', `sample-item-num-${num}`)
  })
});
